module.exports = __webpack_public_path__ + "fonts/5ce6c3505ac15b502e2b781e2a89d283.eot";